<template>
  <div
    class="sli-cell sli-cell--customer"
    :class="`sli-span-${span}`"
  >
    <label
      class="sli-cell__label"
      :for="inputId"
    >اسم صاحب التكليف</label>
    <v-select
      :id="inputId"
      :value="selected"
      :options="filteredOptions"
      :get-option-label="optionLabel"
      :create-option="createOption"
      :dir="'rtl'"
      :clearable="true"
      :filterable="true"
      :taggable="true"
      :loading="loading"
      :disabled="disabled"
      placeholder="ابحث أو اكتب اسم صاحب التكليف"
      class="sli-mini-select"
      @search="onSearch"
      @search:blur="onSearchBlur"
      @input="onSelect"
    >
      <template #no-options="{ search }">
        <span v-if="search">اضغط Enter لحفظ الاسم كما كُتب</span>
        <span v-else>ابدأ بالبحث أو اكتب الاسم</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

function unwrapCustomers(raw) {
  if (Array.isArray(raw)) return raw
  if (Array.isArray(raw?.data)) return raw.data
  if (Array.isArray(raw?.data?.data)) return raw.data.data
  return []
}

export default {
  name: 'SliCustomerSelect',
  components: { vSelect },
  props: {
    land: { type: Object, required: true },
    inputId: { type: String, required: true },
    span: { type: [Number, String], default: 2 },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      searchTimer: null,
      lastSearch: '',
    }
  },
  computed: {
    ...mapGetters({
      customersRaw: 'customers/customers',
    }),
    allOptions() {
      return unwrapCustomers(this.customersRaw)
    },
    filteredOptions() {
      const options = this.allOptions.slice()
      const currentId = this.land.customer_id ? String(this.land.customer_id) : ''
      if (currentId && !options.some(item => String(item.id) === currentId) && this.land.taxpayer_name) {
        options.unshift({ id: this.land.customer_id, name: this.land.taxpayer_name })
      } else if (!currentId && this.land.taxpayer_name) {
        const typed = this.land.taxpayer_name
        if (!options.some(item => this.optionLabel(item) === typed)) {
          options.unshift({ id: null, name: typed, _custom: true })
        }
      }
      return options
    },
    selected() {
      if (this.land.customer_id) {
        return this.filteredOptions.find(item => String(item.id) === String(this.land.customer_id))
          || { id: this.land.customer_id, name: this.land.taxpayer_name || '' }
      }
      if (this.land.taxpayer_name) {
        return { id: null, name: this.land.taxpayer_name, _custom: true }
      }
      return null
    },
  },
  created() {
    if (!this.allOptions.length) this.fetchCustomers('')
  },
  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer)
  },
  methods: {
    optionLabel(option) {
      if (!option) return ''
      if (typeof option === 'string') return option
      return option.name || option.name_ar || ''
    },
    createOption(text) {
      return { id: null, name: String(text || '').trim(), _custom: true }
    },
    onSearch(search, loading) {
      this.lastSearch = search || ''
      if (this.searchTimer) clearTimeout(this.searchTimer)
      if (typeof loading === 'function') loading(true)
      this.searchTimer = setTimeout(() => {
        this.fetchCustomers(search, loading)
      }, 300)
    },
    onSearchBlur() {
      const text = String(this.lastSearch || '').trim()
      if (!text || this.land.customer_id) return
      this.land.taxpayer_name = text
      this.land.customer_id = null
    },
    fetchCustomers(search, loading) {
      this.loading = true
      const query = search ? { search } : {}
      this.$store.dispatch('customers/listCustomers', { query })
        .catch(() => {})
        .finally(() => {
          this.loading = false
          if (typeof loading === 'function') loading(false)
        })
    },
    onSelect(option) {
      if (!option) {
        this.land.customer_id = null
        this.land.taxpayer_name = ''
        this.lastSearch = ''
        return
      }
      if (typeof option === 'string') {
        this.land.customer_id = null
        this.land.taxpayer_name = option.trim()
        return
      }
      if (!option.id || option._custom) {
        this.land.customer_id = null
        this.land.taxpayer_name = this.optionLabel(option)
        return
      }
      this.land.customer_id = option.id
      this.land.taxpayer_name = this.optionLabel(option)
    },
  },
}
</script>
